import { useOutletContext } from "react-router-dom";
import { Instagram, MessageCircle, Mail } from "lucide-react";

export default function Contact() {
  const { settings } = useOutletContext();
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
      <div className="label">Contato</div>
      <h1 className="font-display text-4xl sm:text-6xl font-black mt-2">Vem conectar com a gente.</h1>
      <p className="text-slate-400 mt-4">Dúvidas, ideias ou só pra conversar — estamos aqui.</p>

      <div className="mt-10 grid gap-4 sm:grid-cols-2">
        {settings?.instagram_url && (
          <a data-testid="contact-ig" href={settings.instagram_url} target="_blank" rel="noreferrer" className="ci-card p-6 hover:border-blue-400 flex items-center gap-4">
            <Instagram size={28} className="text-blue-400" />
            <div>
              <div className="label">Instagram</div>
              <div className="font-display text-lg font-bold mt-1">{settings?.instagram_handle || "@conexao.inefavel"}</div>
            </div>
          </a>
        )}
        {settings?.whatsapp_number && (
          <a data-testid="contact-wa" href={`https://wa.me/${settings.whatsapp_number.replace(/\D/g, "")}?text=${encodeURIComponent(settings?.whatsapp_message || "")}`} target="_blank" rel="noreferrer" className="ci-card p-6 hover:border-blue-400 flex items-center gap-4">
            <MessageCircle size={28} className="text-blue-400" />
            <div>
              <div className="label">WhatsApp</div>
              <div className="font-display text-lg font-bold mt-1">Falar com a equipe</div>
            </div>
          </a>
        )}
        {settings?.contact_email && (
          <a href={`mailto:${settings.contact_email}`} className="ci-card p-6 hover:border-blue-400 flex items-center gap-4">
            <Mail size={28} className="text-blue-400" />
            <div>
              <div className="label">E-mail</div>
              <div className="font-display text-lg font-bold mt-1">{settings.contact_email}</div>
            </div>
          </a>
        )}
      </div>

      {(!settings?.instagram_url && !settings?.whatsapp_number && !settings?.contact_email) && (
        <div className="ci-card p-10 mt-10 text-center text-slate-400">Em breve, canais de contato oficiais.</div>
      )}
    </div>
  );
}
